<script setup lang="ts">
// biome-ignore lint/correctness/noUnusedImports: used in <template>
import { store } from '@/app/store';
import { useUiStore } from '@/app/stores/ui';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLanguageSelectorButton> in <template>
import KioskLanguageSelectorButton from './KioskLanguageSelectorButton.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskLogo> in <template>
import KioskLogo from './KioskLogo.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskOperatorTools> in <template>
import KioskOperatorTools from './KioskOperatorTools.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskOverlayHost> in <template>
import KioskOverlayHost from './KioskOverlayHost.vue';
// biome-ignore lint/correctness/noUnusedImports: used via tag <KioskShell> in <template>
import KioskShell from './KioskShell.vue';

interface Props {
  classes?: {
    container?: string;
    inner?: string;
    content?: string;
  };
  isCentered?: boolean;
  isFullscreen?: boolean;
}

withDefaults(defineProps<Props>(), {
  classes: undefined,
  isCentered: false,
  isFullscreen: false,
});

type PlainZone = 'right' | 'bottom-right' | 'bottom' | 'bottom-left';

const PLAIN_ZONES: readonly PlainZone[] = [
  'right',
  'bottom-right',
  'bottom',
  'bottom-left',
];

defineSlots<
  {
    default?: () => unknown;
    'KioskLayout__top-left'?: () => unknown;
    'KioskLayout__top-right'?: () => unknown;
  } & {
    [Zone in (typeof PLAIN_ZONES)[number] as `KioskLayout__${Zone}`]?: () => unknown;
  }
>();

// biome-ignore lint/correctness/noUnusedVariables: used in <template>
const ui = useUiStore();
</script>

<template>
  <KioskShell
    :button-shadows="Boolean(store.kiosk?.button_shadows)"
    :classes="classes"
    :custom-font-face-css-code="store.kioskFontFaceCssCode"
    :is-centered="isCentered"
    :is-fullscreen="isFullscreen"
    :is-step-content-hidden="ui.isStepContentHidden"
  >
    <slot/>

    <template #KioskLayout__top-left>
      <slot name="KioskLayout__top-left">
        <KioskLogo/>
      </slot>
    </template>

    <template #KioskLayout__top-right>
      <slot name="KioskLayout__top-right">
        <KioskLanguageSelectorButton/>
      </slot>
    </template>

    <template v-for="zone in PLAIN_ZONES" #[`KioskLayout__${zone}`]>
      <slot :name="`KioskLayout__${zone}`"/>
    </template>

    <template #KioskShell__auxiliary>
      <KioskOverlayHost/>
      <KioskOperatorTools/>
    </template>
  </KioskShell>
</template>
